import React from 'react';
import './OnlineCourses.css';
import onlineLearning from '../../assets/images/online-learning.jpg';

const OnlineCourses = () => {
  const comingSoonCourses = [
    "Home Care Aide Certification Online",
    "CNA Bridge Program Online",
    "Dementia Care Specialist",
    "Medication Administration",
    "First Aid & CPR for Healthcare Providers",
    "Infection Control in Healthcare",
    "Patient Rights and Ethics"
  ];

  return (
    <main className="online-courses-page">
      {/* Hero Section */}
      <section className="online-hero">
        <div className="container">
          <h1>Online Learning Coming Soon</h1>
          <p>Flexible, high-quality training from anywhere</p>
        </div>
      </section>

      {/* Online Content */}
      <section className="online-content">
        <div className="container">
          <div className="online-grid">
            <div className="online-text">
              <h2>Get High-Quality HCA Training Online</h2>
              <p>
                Our upcoming online courses will provide the same excellent education as our in-person 
                classes with the convenience of learning from home. All courses will be state-approved 
                and taught by our experienced instructors.
              </p>
              
              <div className="features">
                <h3>What to Expect:</h3>
                <ul>
                  <li>Interactive online classroom environment</li>
                  <li>Flexible scheduling options</li>
                  <li>Access to instructors for questions and support</li>
                  <li>Digital resources and materials</li>
                  <li>Progress tracking and assessments</li>
                </ul>
              </div>
              
              <div className="notification">
                <h3>Get Notified When We Launch:</h3>
                <form className="notification-form">
                  <input 
                    type="email" 
                    placeholder="Your email address" 
                    required 
                  />
                  <button type="submit" className="notify-btn">
                    Notify Me
                  </button>
                </form>
              </div>
            </div>
            
            <div className="online-image">
              <img src={onlineLearning} alt="Online learning" />
            </div>
          </div>
          
          {/* Coming Soon Courses */}
          <div className="coming-soon">
            <h2>Courses Launching Soon</h2>
            <div className="courses-list">
              {comingSoonCourses.map((course, index) => (
                <div key={index} className="course-item">
                  <div className="course-icon">📚</div>
                  <p>{course}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default OnlineCourses;